import { Timestamp } from 'firebase/firestore';

// A saved, named territory polygon for a project — drawn on the Maps tool,
// reloadable, annotatable, and (later) convertible into a canvassing workload.
export interface MapArea {
  id: string;
  projectId: string;
  name: string;
  notes?: string;
  paths: { lat: number; lng: number }[];
  color?: string;
  createdBy: string;
  createdByName?: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export type PinCategory = 'bus_stop' | 'community_resource' | 'no_go' | 'warning' | 'other';

// A typed point of interest dropped on the Maps tool (bus stop, resource,
// no-go / warning area, etc.).
export interface MapPin {
  id: string;
  projectId: string;
  category: PinCategory;
  name?: string;
  notes?: string;
  location: { lat: number; lng: number };
  createdBy: string;
  createdByName?: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export const PIN_CATEGORIES: { value: PinCategory; label: string; color: string; emoji: string }[] = [
  { value: 'bus_stop', label: 'Bus stop', color: '#2563EB', emoji: '🚌' },
  { value: 'community_resource', label: 'Community resource', color: '#059669', emoji: '🏫' },
  { value: 'no_go', label: 'No-go area', color: '#DC2626', emoji: '⛔' },
  { value: 'warning', label: 'Warning', color: '#D97706', emoji: '⚠️' },
  { value: 'other', label: 'Other', color: '#6B7280', emoji: '📍' },
];

export const pinCategoryMeta = (cat: PinCategory) =>
  PIN_CATEGORIES.find(c => c.value === cat) || PIN_CATEGORIES[PIN_CATEGORIES.length - 1];
